









import { Component, Vue, Prop } from 'vue-property-decorator';
import { BookService, BookViewModel } from '../../../../easysmart.resource.admin.web/src/api/book';
import global from '../../utils/global';
@Component({})
export default class BookDetail extends Vue {
  @Prop() private bookId!: number;
  @Prop() private bookGuid!: string;
  private service: BookService = new BookService();
  private data: BookViewModel = this.service.NewModel;
  private imgUrl: string = `${global.BACKGROUND_URL}\\book\\`;
  private mounted() {
    // console.log(this.bookId);

    // this.service.Get(this.bookId).then((response: any) => {
    //   this.data = response;
    // });
    this.service.GetByGuid(this.bookGuid).then((response: any) => {
      this.data = response;
    });
  }
}
